import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _toConsumableArray from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TagList from 'src/store/models/TagList';
import Tag from 'src/store/models/Tag';
import TagListRow from "./TagListRow/index";
import TagRow from "./TagRow/index";
import { colorUtils } from 'src/mixins/colors-utils';
import { uniqueId } from 'lodash';
import ProjectTagList from 'src/store/models/ProjectTagList';
import ProjectTag from 'src/store/models/ProjectTag';
import Vue from 'vue';
import { BUDGET_TYPE as _BUDGET_TYPE } from 'src/boot/constants';
import SubscriptionTypeUpgrade from 'src/components/SubscriptionTypeUpgrade';
export default {
  mixins: [colorUtils],
  components: {
    // ColorPicker,
    TagListRow: TagListRow,
    TagRow: TagRow,
    SubscriptionTypeUpgrade: SubscriptionTypeUpgrade
  },
  props: {
    project: {
      type: Object,
      default: null
    },
    integrationProjectId: {
      default: null
    },
    selection: {
      type: Boolean,
      default: false
    },
    selectedItems: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showAllTagLists: {
      type: Boolean,
      default: true
    },
    showTotals: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: false
    },
    canAddEntities: {
      type: Boolean,
      default: true
    },
    canDeleteEntities: {
      type: Boolean,
      default: true
    },
    canArchiveEntities: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      loading: false,
      filters: {
        text: '',
        show_archived: !!this.project
      },
      pagination: {
        page: 1,
        rowsPerPage: 0,
        sortBy: 'name',
        descending: false
      },
      allTagLists: [],
      creatingTagList: false,
      originalSelectedItems: this.selectedItems
    };
  },
  watch: {
    internalSelectedItems: function internalSelectedItems(value) {
      this.$emit('update:selectedItems', value);
    },
    tagLists: function tagLists() {
      var _this = this;

      setTimeout(function () {
        if (_this.$refs.tagListTable) {
          _this.$refs.tagListTable.resetVirtualScroll();
        }
      }, 100);
    }
  },
  computed: {
    BUDGET_TYPE: function BUDGET_TYPE() {
      return _BUDGET_TYPE;
    },
    tagLists: function tagLists() {
      var _this2 = this;

      return this.showAllTagLists ? this.allTagLists : this.allTagLists.reduce(function (acc, tagList) {
        var selectedTagList = _this2.selectedItems.find(function (selectedTagList) {
          return selectedTagList.tag_list_id === tagList.tag_list_id;
        });

        if (selectedTagList) {
          acc.push(_objectSpread(_objectSpread({}, tagList), {}, {
            tags: tagList.tags.filter(function (tag) {
              return selectedTagList && selectedTagList.tags.find(function (selectedTag) {
                return tag.tag_id === selectedTag.tag_id;
              });
            })
          }));
        }

        return acc;
      }, []);
    },
    activeTagLists: function activeTagLists() {
      return this.tagLists.filter(function (tagList) {
        return tagList.is_active;
      });
    },
    allSelected: {
      get: function get() {
        if (this.selectableTagLists.filter(function (tagList) {
          return !tagList.selected;
        }).length > 0 && this.selectableTagLists.filter(function (tagList) {
          return tagList.selected;
        }).length > 0) {
          return null;
        } else return !this.selectableTagLists.filter(function (tagList) {
          return !tagList.selected;
        }).length > 0;
      },
      set: function set(val) {
        var _this3 = this;

        this.allTagLists.forEach(function (tagList) {
          if (_this3.isTagListSelectable(tagList)) {
            _this3.selectTagList(tagList, val);
          }
        });
      }
    },
    projectId: function projectId() {
      return this.project ? this.project.project_id : null;
    },
    columns: function columns() {
      var columns = [{
        name: 'name',
        field: 'name',
        label: this.$tc('general.tag_list', 1),
        align: 'left',
        sortable: true,
        headerStyle: 'text-weight: bold;',
        style: 'max-width: 300px;'
      }];
      columns.push({
        name: 'integration_code',
        field: 'integration_code',
        label: '',
        style: 'width: 50px',
        align: 'center',
        sortable: false
      });

      if (this.filters.show_archived) {
        columns.push({
          name: 'status',
          field: 'status',
          label: '',
          style: 'width: 120px; padding-right: 20px',
          align: 'center',
          sortable: false
        });
      }

      if (this.projectId && !this.isSmallScreen) {
        if (this.project.budget && (this.project.budget.type !== 'cost' || this.me.is_owner)) {
          columns.push({
            name: 'budget_minutes',
            field: 'budget_minutes',
            label: this.project.budget.type === _BUDGET_TYPE.TIME ? this.$t('general.time_budget') : this.$t('general.budget_amount'),
            align: 'left',
            sortable: true,
            headerStyle: 'text-weight: bold; width: 200px'
          });
        }
      } else if (!this.project && !this.isSmallScreen) {
        columns.push({
          name: 'projects_count',
          field: 'projects_count',
          label: this.$tc('general.project', 2),
          style: 'width: 75px',
          sortable: true,
          headerStyle: 'text-weight: bold; width: 75px'
        });
        columns.push({
          name: 'total_time',
          field: 'total_time',
          label: this.$t('general.time_tracked'),
          style: 'width: 100px',
          align: 'right',
          sortable: true,
          headerStyle: 'text-weight: bold; width: 100px'
        });
      }

      return [].concat(columns);
    },
    selectableTagLists: function selectableTagLists() {
      var _this4 = this;

      return this.allTagLists.filter(function (tagList) {
        return _this4.isTagListSelectable(tagList);
      });
    },
    internalSelectedItems: function internalSelectedItems() {
      var _this5 = this;

      return this.allTagLists.reduce(function (acc, tagList) {
        var _tagList$pivot, _tagList$pivot$budget, _tagList$pivot2, _tagList$pivot2$budge, _tagList$pivot3;

        // eslint-disable-next-line camelcase
        var tags = tagList.tags.filter(function (tag) {
          var _tag$pivot, _tag$pivot$budget, _tag$pivot2, _tag$pivot2$budget;

          return tag.selected || _this5.project && _this5.project.tag_usage === 'ALL_TAGS' && (((_tag$pivot = tag.pivot) === null || _tag$pivot === void 0 ? void 0 : (_tag$pivot$budget = _tag$pivot.budget) === null || _tag$pivot$budget === void 0 ? void 0 : _tag$pivot$budget.budget_minutes) || ((_tag$pivot2 = tag.pivot) === null || _tag$pivot2 === void 0 ? void 0 : (_tag$pivot2$budget = _tag$pivot2.budget) === null || _tag$pivot2$budget === void 0 ? void 0 : _tag$pivot2$budget.budget_amount));
        }); // eslint-disable-next-line camelcase

        if (tags.length || _this5.project && _this5.project.tag_usage === 'ALL_TAGS' && ((_tagList$pivot = tagList.pivot) !== null && _tagList$pivot !== void 0 && (_tagList$pivot$budget = _tagList$pivot.budget) !== null && _tagList$pivot$budget !== void 0 && _tagList$pivot$budget.budget_minutes || (_tagList$pivot2 = tagList.pivot) !== null && _tagList$pivot2 !== void 0 && (_tagList$pivot2$budge = _tagList$pivot2.budget) !== null && _tagList$pivot2$budge !== void 0 && _tagList$pivot2$budge.budget_amount) || (_tagList$pivot3 = tagList.pivot) !== null && _tagList$pivot3 !== void 0 && _tagList$pivot3.required || tagList.selected) {
          acc.push(_objectSpread(_objectSpread({}, tagList), {}, {
            tags: tags
          }));
        }

        return acc;
      }, []);
    },
    totalTagListsBudget: function totalTagListsBudget() {
      var _this$project$tag_lis,
          _this6 = this;

      return (_this$project$tag_lis = this.project.tag_lists) === null || _this$project$tag_lis === void 0 ? void 0 : _this$project$tag_lis.reduce(function (total, tagList) {
        if (tagList.pivot.budget) {
          total += _this6.project.budget.type === _BUDGET_TYPE.TIME ? tagList.pivot.budget.budget_minutes : parseFloat(tagList.pivot.budget.budget_amount);
        }

        return total;
      }, 0);
    },
    expandAll: function expandAll() {
      return Tag.query().count() < 5;
    }
  },
  methods: {
    loadTagLists: function loadTagLists() {
      var _this7 = this;

      this.allTagLists = _toConsumableArray(TagList.query().with('tags').where(function (tagList) {
        return !tagList.integration_project_id || _this7.integrationProjectId !== -1 && tagList.integration_project_id === _this7.integrationProjectId;
      }).all().map(function (tagList) {
        var _this7$project2;

        tagList.key = tagList.tag_list_id || uniqueId();

        var selectedTagList = _this7.selectedItems.find(function (selectedTagList) {
          return tagList.tag_list_id === selectedTagList.tag_list_id;
        });

        tagList.pivot = {
          required: false,
          budget: {
            budget_minutes: 0,
            budget_amount: 0
          }
        };
        tagList.selected = !!selectedTagList;

        if (_this7.projectId && selectedTagList) {
          var tagListPivot = ProjectTagList.find([_this7.projectId, selectedTagList.tag_list_id]);

          if (!Object.hasOwn(selectedTagList, 'required')) {
            tagList.pivot.required = !!(tagListPivot !== null && tagListPivot !== void 0 && tagListPivot.required);
          }

          if (!Object.hasOwn(selectedTagList, 'budget')) {
            tagList.pivot.budget = tagListPivot !== null && tagListPivot !== void 0 && tagListPivot.budget ? tagListPivot.budget : {
              budget_minutes: 0,
              budget_amount: 0
            };
          }
        }

        tagList.selected = !!selectedTagList;
        tagList.tags.map(function (tag) {
          var _this7$project;

          tag.key = tag.tag_id || uniqueId();
          tag.pivot = {
            budget: {
              budget_minutes: 0,
              budget_amount: 0
            }
          };
          tag.selected = false;

          if (selectedTagList) {
            var selectedTag = selectedTagList.tags.find(function (selectedTag) {
              return tag.tag_id === selectedTag.tag_id;
            });
            tag.selected = !!selectedTag;
            tag.pivot.budget = selectedTag ? selectedTag.pivot.budget : {
              budget_minutes: 0,
              budget_amount: 0
            };

            if (_this7.projectId && selectedTag) {
              if (selectedTag) {
                var tagPivot = ProjectTag.find([_this7.projectId, selectedTag.tag_id]);

                if (tagPivot && !Object.hasOwn(selectedTag, 'budget_minutes')) {
                  tag.pivot.budget = tagPivot.budget ? tagPivot.budget : {
                    budget_minutes: 0,
                    budget_amount: 0
                  };
                }
              }
            }
          }

          if ((_this7$project = _this7.project) !== null && _this7$project !== void 0 && _this7$project.budget && _this7.project.budget.type === _BUDGET_TYPE.COST && !_this7.me.is_owner) {
            delete tag.pivot.budget;
          }

          return tag;
        });

        if ((_this7$project2 = _this7.project) !== null && _this7$project2 !== void 0 && _this7$project2.budget && _this7.project.budget.type === _BUDGET_TYPE.COST && !_this7.me.is_owner) {
          delete tagList.pivot.budget;
        }

        return tagList;
      }));
    },
    getTagListSelectedTags: function getTagListSelectedTags(tagList) {
      var _this8 = this;

      return tagList.tags.filter(function (tag) {
        return _this8.isTagInCurrentSelectedItems(tag);
      });
    },
    isTagInOriginalSelectedItems: function isTagInOriginalSelectedItems(tag) {
      return this.originalSelectedItems.map(function (tagList) {
        return tagList.tags;
      }).flat().find(function (selectedTag) {
        return selectedTag.tag_id === tag.tag_id;
      });
    },
    isTagListInOriginalSelectedItems: function isTagListInOriginalSelectedItems(tagList) {
      return this.originalSelectedItems.find(function (selectedTagList) {
        return selectedTagList.tag_list_id === tagList.tag_list_id;
      });
    },
    isTagInCurrentSelectedItems: function isTagInCurrentSelectedItems(tag) {
      return this.internalSelectedItems.map(function (tagList) {
        return tagList.tags;
      }).flat().find(function (selectedTag) {
        return selectedTag.tag_id === tag.tag_id;
      });
    },
    isTagListInCurrentSelectedItems: function isTagListInCurrentSelectedItems(tagList) {
      return this.internalSelectedItems.find(function (selectedTagList) {
        return selectedTagList.tag_list_id === tagList.tag_list_id;
      });
    },
    isTagListNew: function isTagListNew(tagList) {
      return this.project && this.project.tag_usage !== 'ALL_TAGS' && !ProjectTagList.find([this.projectId, tagList.tag_list_id]);
    },
    isTagNew: function isTagNew(tag) {
      return this.project && this.project.tag_usage !== 'ALL_TAGS' && !ProjectTag.find([this.projectId, tag.tag_id]);
    },
    importTagLists: function importTagLists(tagLists) {
      var _this9 = this;

      tagLists.forEach(function (tagList) {
        TagList.api().store(tagList).then(function (result) {
          _this9.$q.notify({
            type: 'positive',
            message: _this9.$t('genera.created_last_tag_list')
          });

          var newTagList = result.response.data;

          _this9.addNewTagList(newTagList);

          newTagList = _this9.allTagLists.find(function (item) {
            return item.tag_list_id === newTagList.tag_list_id;
          });
          tagList.tags.forEach(function (tag) {
            Tag.api().store(_objectSpread(_objectSpread({}, tag), {}, {
              tag_list_id: newTagList.tag_list_id
            })).then(function (result) {
              _this9.addNewTag(newTagList, null, result.response.data);

              _this9.$q.notify({
                type: 'positive',
                message: _this9.$t('components.tagManagement.created_last_tag_list')
              });
            });
          });
        });
      });
    },
    updateTagList: function updateTagList(key, data) {
      var myTagListIndex = this.allTagLists.findIndex(function (item) {
        return item.key === key;
      });
      var myTagList = this.allTagLists[myTagListIndex];
      var tags = myTagList.tags;

      if (Object.hasOwn(data, 'delete')) {
        tags = myTagList.tags.map(function (tag) {
          tag.delete = data.delete;
          return tag;
        });
      }

      this.allTagLists.splice(myTagListIndex, 1, _objectSpread(_objectSpread(_objectSpread({}, myTagList), data), {}, {
        pivot: _objectSpread(_objectSpread({}, myTagList.pivot), data.pivot),
        tags: tags
      }));
      this.$emit('edited');
    },
    updateTag: function updateTag(tagListKey, tagKey, data) {
      var myTagList = this.allTagLists.find(function (item) {
        return item.key === tagListKey;
      });
      var myTagIndex = myTagList.tags.findIndex(function (tag) {
        return tag.key === tagKey;
      });
      var myTag = myTagList.tags[myTagIndex];

      if (Object.hasOwn(data, 'delete')) {
        if (!data.delete) {
          myTagList.delete = 0;
        }
      }

      myTagList.tags.splice(myTagIndex, 1, _objectSpread(_objectSpread(_objectSpread({}, myTag), data), {}, {
        pivot: _objectSpread(_objectSpread({}, myTag.pivot), data.pivot)
      }));
      this.$emit('edited');
    },
    isTagListSelectable: function isTagListSelectable(tagList) {
      return tagList.is_active && tagList.tags.filter(function (tag) {
        return tag.tag_id && tag.is_active;
      }).length > 0;
    },
    filterMethod: function filterMethod() {
      var _this10 = this;

      var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return rows.filter(function (row) {
        var showArchived = row.is_active || _this10.filters.show_archived;
        var visible = true;

        if (_this10.filters.text) {
          visible && (visible = !row.name || row.name.toLowerCase().indexOf(_this10.filters.text.toLowerCase()) > -1);
        } // show even tag lists who match filters, but hide even active tags when the tagList is archived and show_archived is false


        return (_this10.filterMethod(row.tags).length || visible) && showArchived;
      });
    },

    /**
     * Sorts the tag lists based on the specified criteria.
     * @param {Array} tagLists - The array of tag lists to be sorted.
     * @param {string} sortBy - The property to sort by (e.g., 'name', 'tag_id').
     * @param {boolean} descending - Indicates whether to sort in descending order.
     * @returns {Array} - The sorted array of tag lists.
     */
    sortMethod: function sortMethod(tagLists, sortBy, descending) {
      return tagLists.reduce(function (acc, tagList) {
        acc.push(_objectSpread(_objectSpread({}, tagList), {}, {
          tags: tagList.tags.sort(function (a, b) {
            if (!a.tag_id || !b.tag_id) {
              // if one of the tags is new, put it at the start
              return 1;
            } else if (descending) {
              return sortBy === 'name' ? b[sortBy] && b[sortBy].localeCompare(a[sortBy]) : b[sortBy] - a[sortBy];
            } else {
              return sortBy === 'name' ? a[sortBy] && a[sortBy].localeCompare(b[sortBy]) : a[sortBy] - b[sortBy];
            }
          })
        }));
        return acc;
      }, []).sort(function (a, b) {
        if (!a.tag_list_id || !b.tag_list_id) {
          // if one of the tag lists is new, put it at the start
          return 1;
        } else if (descending) {
          return sortBy === 'name' ? b[sortBy] && b[sortBy].localeCompare(a[sortBy]) : b[sortBy] - a[sortBy];
        } else {
          return sortBy === 'name' ? a[sortBy] && a[sortBy].localeCompare(b[sortBy]) : a[sortBy] - b[sortBy];
        }
      });
    },
    removeTagList: function removeTagList(key) {
      var index = this.allTagLists.findIndex(function (item) {
        return item.key === key;
      });
      this.allTagLists.splice(index, 1);
      this.$emit('edited');
    },
    removeTag: function removeTag(tagList, key) {
      var myTagList = this.allTagLists.find(function (item) {
        return item.tag_list_id === tagList.tag_list_id;
      });
      var index = myTagList.tags.findIndex(function (item) {
        return item.key === key;
      });
      myTagList.tags.splice(index, 1);
      this.$emit('edited');
    },
    addNewTagList: function addNewTagList(tagListData) {
      var newTagList = new TagList();

      if (tagListData) {
        newTagList = _objectSpread(_objectSpread({
          selected: true
        }, newTagList), tagListData);
      } else {
        newTagList = new TagList();
        newTagList.color = this.getRandomColor();
        newTagList.text_color = this.textColorFromBackground(newTagList.color);

        if (this.project) {
          newTagList.pivot = {
            required: false,
            budget_minutes: 0
          };
        }
      }

      newTagList.key = uniqueId();
      this.allTagLists.unshift(newTagList);
      this.$emit('edited');
    },
    addNewTag: function addNewTag(tagList) {
      var tableRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var tagData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (tableRow) {
        tableRow.expand = true;
      }

      var newTag = new Tag();
      newTag.key = uniqueId(); // we choose not to change this to avoid too much conflicts during the future monetary budgets merge

      newTag.pivot = {
        budget_minutes: 0
      };

      if (tagData) {
        newTag = _objectSpread(_objectSpread({
          selected: true
        }, newTag), tagData);
      }

      tagList.tags.unshift(newTag);
      this.$emit('edited');
    },
    selectTagList: function selectTagList(tagList, value) {
      tagList.selected = value;
      this.$emit('update:selectedItems', this.internalSelectedItems);
    }
  },
  mounted: function mounted() {
    var _this11 = this;

    this.loadTagLists();
    Vue.prototype.$eventHub.$on('tag-lists-changed', function () {
      if (!_this11.allTagLists.length) {
        _this11.loadTagLists();
      }
    });
  }
};